module.exports = __webpack_public_path__ + "media/components/lesson4/common/statics/image7-1a6823165261fbd358e01852893db955.jpg";